import { MondayApiQueryInstance } from "../../services/monday/monday-service-ts";
import axios from "axios";
import logger from "../../lib/logger";

const uri = process.env.REACT_APP_URI;

export interface AddNewItemParams {
  targetGroupId: string;
  targetBoardId: string;
  userId: string;
  accountId: string;
  currentBoard: string;
  itemIds: number[];
  token: string;
  processSubitems: boolean;
  processUpdates: boolean;
  removeItemDisabled: (id: string) => void;
  removeItemLoading: (id: string) => void;
  batchSize?: number;
  showStartToast?: boolean;
}

const broadcastProgress = (type: "add-item-started" | "add-item-failed") => {
  try {
    const ch = new BroadcastChannel(ADD_ITEM_PROGRESS_CHANNEL);
    ch.postMessage({ type });
    ch.close();
  } catch {
    // BroadcastChannel not supported
  }
};

export const addNewItem = async (params: AddNewItemParams) => {
  const {
    targetGroupId,
    targetBoardId,
    userId,
    accountId,
    currentBoard,
    itemIds,
    token,
    processSubitems,
    processUpdates,
    removeItemDisabled,
    removeItemLoading,
    batchSize,
    showStartToast = true,
  } = params;

  try {
    broadcastProgress("add-item-started");

    if (showStartToast) {
      await MondayApiQueryInstance.mondayToastNotification(
        "Your item is being added to the other board. You can continue using monday meanwhile!",
        "info",
        10000,
      );
    }

    await axios.post(
      `${uri}/simb/add-item-and-sync`,
      {
        payload: {
          accountId,
          itemIdArray: itemIds,
          originBoardId: currentBoard,
          target: { boardId: targetBoardId, groupId: targetGroupId },
          processSubItem: processSubitems,
          processUpdates,
          batchSize,
        },
      },
      {
        headers: {
          userid: userId,
          Authorization: `Bearer ${token}`,
        },
      },
    );
  } catch (error: unknown) {
    logger.error("Error adding new item to board", { error });
    removeItemDisabled(`${targetGroupId}-${targetBoardId}`);
    removeItemLoading(`${targetGroupId}-${targetBoardId}`);
    // The request never reached the sync, so no socket result is coming. Without this the
    // progress banner sat at 90% until the 2-minute fallback, then reported success.
    broadcastProgress("add-item-failed");
    throw error;
  }
};

export const ADD_ITEM_PROGRESS_CHANNEL = "simb-add-item-progress";
